import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import SaaSHeader from './header/SaaSHeader';
import ZimbraSaaS from './products/ZimbraSaaS';
import SSOSaaS from './products/SSOSaaS';
import NextcloudSaaS from './products/NextcloudSaaS';

const SaaSSection = () => {
  const { t } = useTranslatedContent('saas');

  return (
    <div id="cloud" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SaaSHeader 
          title={t('title')}
          subtitle={t('subtitle')}
        />
        <div className="mt-16 space-y-20">
          <div id="saas-zimbra">
            <ZimbraSaaS />
          </div>
          <div id="saas-sso">
            <SSOSaaS />
          </div>
          <div id="saas-nextcloud">
            <NextcloudSaaS />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaaSSection;